import type {
  BundleCabinMarkupFormRow,
  BundleCabinTypeMarkup,
  BundleCabinTypeMarkupInput,
} from '~/components/Cruises/pages/Bundles/types';

const FIXED_CABIN_TYPE_FIELDS: Array<{ cabinType: string; label: string }> = [
  { cabinType: 'inside', label: 'Inside' },
  { cabinType: 'oceanview', label: 'Oceanview' },
  { cabinType: 'balcony', label: 'Balcony' },
  { cabinType: 'suite', label: 'Suite' },
];

export function buildFixedCabinMarkupRows(): Array<BundleCabinMarkupFormRow> {
  return FIXED_CABIN_TYPE_FIELDS.map((field) => ({
    cabinType: field.cabinType,
    label: field.label,
    markupPercent: '',
    flightCreditAmount: '',
  }));
}

export function mergeFixedCabinMarkupRows(markups: Array<BundleCabinTypeMarkup>): Array<BundleCabinMarkupFormRow> {
  const markupByCabinType = new Map(markups.map((row) => [normalizeBundleCabinTypeKey(row.cabinType), row]));

  return FIXED_CABIN_TYPE_FIELDS.map((field) => {
    const existing = markupByCabinType.get(field.cabinType);
    return {
      cabinType: field.cabinType,
      label: field.label,
      markupPercent: existing ? existing.markup * 100 : '',
      flightCreditAmount: existing ? existing.flightCreditAmount : '',
    };
  });
}

export function normalizeBundleCabinTypeKey(cabinType: string): string {
  return cabinType.trim().toLowerCase();
}

export function validateBundleCabinMarkupRows(rows: Array<BundleCabinMarkupFormRow>): string | undefined {
  for (const row of rows) {
    if (row.markupPercent === '') {
      return `Enter markup (%) for all cabin types, including ${row.label}`;
    }
    if (row.markupPercent < 0 || row.markupPercent > 100) {
      return 'Per-cabin markup must be between 0 and 100%';
    }
    if (row.flightCreditAmount === '') {
      return `Enter flight credit ($ per person) for all cabin types, including ${row.label}`;
    }
    if (row.flightCreditAmount < 0) {
      return 'Per-cabin flight credit must be greater than or equal to 0';
    }
  }
  return undefined;
}

export function bundleCabinMarkupRowsToApi(rows: Array<BundleCabinMarkupFormRow>): Array<BundleCabinTypeMarkupInput> {
  return rows.map((row) => {
    if (row.markupPercent === '' || row.flightCreditAmount === '') {
      throw new Error('bundleCabinMarkupRowsToApi expects validated, complete cabin markup rows');
    }
    return {
      cabinType: row.cabinType.trim(),
      markup: row.markupPercent / 100,
      flightCreditAmount: row.flightCreditAmount,
    };
  });
}
